<div class="row g-2 mb-3 kpi-grid" *ngIf="summary as s; else emptyTpl">
    <div class="col-md col-sm-6">
        <div class="kpi-card kpi-total">
            <div class="kpi-icon-wrap">
                <mat-icon>description</mat-icon>
            </div>
            <div class="kpi-text">
                <div class="kpi-value">{{ s.total_documents }}</div>
                <div class="kpi-label">Total documente</div>
            </div>
        </div>
    </div>
    <div class="col-md col-sm-6">
        <div class="kpi-card kpi-progress">
            <div class="kpi-icon-wrap">
                <mat-icon>autorenew</mat-icon>
            </div>
            <div class="kpi-text">
                <div class="kpi-value">{{ s.in_lucru }}</div>
                <div class="kpi-label">În lucru</div>
            </div>
        </div>
    </div>
    <div class="col-md col-sm-6">
        <div class="kpi-card kpi-success">
            <div class="kpi-icon-wrap">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="kpi-text">
                <div class="kpi-value">{{ s.finalizat }}</div>
                <div class="kpi-label">Finalizat</div>
            </div>
        </div>
    </div>
    <div class="col-md col-sm-6">
        <div class="kpi-card kpi-warn">
            <div class="kpi-icon-wrap">
                <mat-icon>hourglass_empty</mat-icon>
            </div>
            <div class="kpi-text">
                <div class="kpi-value">{{ s.nepreluat }}</div>
                <div class="kpi-label">Nepreluat</div>
            </div>
        </div>
    </div>
    <div class="col-md col-sm-6">
        <div class="kpi-card kpi-danger">
            <div class="kpi-icon-wrap">
                <mat-icon>cancel</mat-icon>
            </div>
            <div class="kpi-text">
                <div class="kpi-value">{{ s.invalidat }}</div>
                <div class="kpi-label">Invalidat</div>
            </div>
        </div>
    </div>
    <div class="col-md col-sm-6" *ngIf="s.other > 0">
        <div class="kpi-card kpi-other">
            <div class="kpi-icon-wrap">
                <mat-icon>help_outline</mat-icon>
            </div>
            <div class="kpi-text">
                <div class="kpi-value">{{ s.other }}</div>
                <div class="kpi-label">Alte stări</div>
            </div>
        </div>
    </div>
</div>

<ng-template #emptyTpl>
    <div class="kpi-empty">Nu există date pentru afișare. Setează filtrele și apasă <strong>Afișare</strong>.</div>
</ng-template>
